import { MapRouteBlockTypeEnum } from "../enums";

/** Map blocks that defer fitBounds during bulk grid selection. */
export const MAP_ROUTE_BLOCK_TYPES_WITH_BULK_AUTOFIT_SUSPEND: ReadonlySet<MapRouteBlockTypeEnum> =
  new Set([
    MapRouteBlockTypeEnum.LiveMap,
    MapRouteBlockTypeEnum.GridMultiSelect,
    MapRouteBlockTypeEnum.GridSingleSelect,
  ]);

/** Live map: defer heavy map work when selection is at least this large. */
export const LIVE_MAP_DEFER_MAP_RENDER_MIN_SELECTED = 20;
